import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { levarVoltaParaEquipe } from './features/equipe/microsoft'

// Volta do login Microsoft da equipe, antes do roteador decidir a rota.
levarVoltaParaEquipe()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
